module.exports = __webpack_public_path__ + "img/dollar.e64684ca.svg";